import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AppShell from "../../components/AppShell";
import api from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { toast } from "sonner";

export default function AdminActivations() {
  const { t } = useTranslation();
  const [codes, setCodes] = useState([]);
  const [form, setForm] = useState({ manufacturer: "Sunnytab", device_model: "Sunnytab S10", trial_days: 30, count: 10 });

  async function load() { const r = await api.get("/admin/activations"); setCodes(r.data); }
  useEffect(() => { load(); }, []);

  async function create() {
    try {
      const r = await api.post("/admin/activations/bulk", form);
      toast.success(`${r.data.created} ✓`); load();
    } catch (e) { toast.error(t("errors.generic")); }
  }

  const used = codes.filter((c) => c.used).length;

  return (
    <AppShell>
      <h1 className="font-adult font-bold text-3xl text-slate-900">{t("admin.activationsTitle")}</h1>
      <p className="text-slate-600">{t("admin.activationsSubtitle")}</p>

      <div className="hb-card p-5 mt-5 grid sm:grid-cols-5 gap-3 items-end">
        <div><Label>{t("admin.manufacturer")}</Label><Input value={form.manufacturer} onChange={(e) => setForm({ ...form, manufacturer: e.target.value })} data-testid="act-mfr" /></div>
        <div><Label>{t("admin.deviceModel")}</Label><Input value={form.device_model} onChange={(e) => setForm({ ...form, device_model: e.target.value })} /></div>
        <div><Label>{t("admin.trialDays")}</Label><Input type="number" value={form.trial_days} onChange={(e) => setForm({ ...form, trial_days: Number(e.target.value) })} /></div>
        <div><Label>{t("admin.count")}</Label><Input type="number" value={form.count} onChange={(e) => setForm({ ...form, count: Number(e.target.value) })} data-testid="act-count" /></div>
        <Button className="rounded-full bg-slate-900 text-white hover:bg-slate-800" onClick={create} data-testid="act-generate">{t("admin.generate")}</Button>
      </div>

      <div className="grid md:grid-cols-3 gap-4 mt-6">
        <div className="hb-card p-4"><div className="text-xs uppercase tracking-widest text-slate-500 font-semibold">{t("admin.totalCodes")}</div><div className="font-adult font-bold text-2xl">{codes.length}</div></div>
        <div className="hb-card p-4"><div className="text-xs uppercase tracking-widest text-slate-500 font-semibold">{t("admin.activated")}</div><div className="font-adult font-bold text-2xl">{used}</div></div>
        <div className="hb-card p-4"><div className="text-xs uppercase tracking-widest text-slate-500 font-semibold">{t("admin.available")}</div><div className="font-adult font-bold text-2xl">{codes.length - used}</div></div>
      </div>

      <div className="mt-6 hb-card p-0 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-100 text-slate-700 text-left">
            <tr><th className="p-2">{t("admin.codeCol")}</th><th className="p-2">{t("admin.manufacturer")}</th><th className="p-2">{t("admin.deviceModel")}</th><th className="p-2">{t("admin.trialDays")}</th><th className="p-2">{t("admin.statusCol")}</th><th className="p-2">{t("admin.usedAt")}</th></tr>
          </thead>
          <tbody>
            {codes.slice(0, 200).map((c) => (
              <tr key={c.id} className="border-t border-slate-200">
                <td className="p-2 font-mono">{c.code}</td>
                <td className="p-2">{c.manufacturer}</td>
                <td className="p-2">{c.device_model || "—"}</td>
                <td className="p-2">{c.trial_days}d</td>
                <td className="p-2">{c.used ? <span className="text-green-700 font-semibold">{t("admin.activated").toLowerCase()}</span> : <span className="text-slate-500">{t("admin.available").toLowerCase()}</span>}</td>
                <td className="p-2">{c.used_at ? new Date(c.used_at).toLocaleString() : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </AppShell>
  );
}
